<div class="row mb-lg-5">
  <div class="col-lg-6">
    <section class="card mb-3 mb-lg-0">
      <sale-general-card
        [readonly]="
          !(
            hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
          )
        "
      ></sale-general-card>
    </section>
  </div>
  <div class="col-lg-6">
    <!-- Card -->
    <section
      class="card mb-3"
      *ngIf="refundableAmount$ | async as refundableAmount"
    >
      <!-- Header -->
      <div class="card-header">
        <h3 class="card-title">
          <i role="img" class="fa fa-credit-card" aria-hidden="true"></i>
          {{ 'subscriptionModule.refund' | translate }}
        </h3>
      </div>
      <!-- End Header -->

      <!-- Body -->
      <div class="card-body" data-test-id="refund-section">
        <div class="alert alert-warning" role="alert">
          <h4 class="alert-heading"
            >{{ 'paymentModule.calculatedRefundAmount' | translate }}
            <span data-test-id="refund-amount">{{
              refundableAmount | currency
            }}</span>
          </h4>

          <p>{{ 'paymentModule.selectRefundAmountSubtext' | translate }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <button
            type="button"
            class="btn btn-primary"
            (click)="onClickRefund('balance')"
            data-test-id="refund-to-balance-button"
          >
            {{ 'subscriptionModule.refundBalance' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="onClickRefund('alreadyRefunded')"
            data-test-id="already-refunded-button"
          >
            {{ 'saleModule.refunded' | translate }}
          </button>

          <button
            *ngIf="
              (canDoPspRefund$ | async) &&
              (pspPartialRefundAwaitingCapture$ | async) === false
            "
            type="button"
            class="btn btn-primary"
            (click)="onClickRefund('psp')"
            data-test-id="refund-to-psp-button"
          >
            {{ 'subscriptionModule.refund' | translate }} PSP
          </button>
        </div>
        <p
          class="text-muted mt-2 mb-0"
          *ngIf="
            (canDoPspRefund$ | async) &&
            (pspPartialRefundAwaitingCapture$ | async)
          "
          data-test-id="psp-refund-awaiting-capture-hint"
        >
          {{ 'paymentModule.pspRefundAwaitingCapture' | translate }}
        </p>
      </div>
    </section>
    <!-- End Body -->
    <!-- End Card -->

    <!-- Failed PSP refund: let the admin acknowledge and close the pending
         operation without moving money -->
    <section
      class="card mb-3"
      *ngIf="pendingResolveOperationId$ | async as pendingOperationId"
      data-test-id="resolve-failed-refund-section"
    >
      <div class="card-header">
        <h3 class="card-title">
          <i role="img" class="fa fa-credit-card" aria-hidden="true"></i>
          {{ 'paymentModule.failedRefundTitle' | translate }}
        </h3>
      </div>
      <div class="card-body">
        <p class="text-muted">
          {{ 'paymentModule.failedRefundHint' | translate }}
        </p>
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onAcceptAndClose(pendingOperationId)"
          data-test-id="accept-and-close-refund-button"
        >
          {{ 'paymentModule.acceptAndCloseFailedRefund' | translate }}
        </button>
      </div>
    </section>

    <sale-payment-tab
      [readonly]="
        !(
          hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
          | async
        )
      "
      [saleId]="saleId$ | async"
    ></sale-payment-tab>
  </div>
</div>

<sale-sale-item-tab
  [readonly]="
    !(
      hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
      | async
    )
  "
  [saleId]="saleId$ | async"
></sale-sale-item-tab>
